import React from "react";
import "./style.css";

function Circular() {
  return <span className="loading--circular"></span>;
}

function Loading() {
  return (
    <div className="loading-container">
      <Circular />
    </div>
  );
}

export default Loading;
